<template>
  <v-card outlined class="dashboard-card">
    <v-toolbar flat class="dashboard-card__toolbar">
      <v-btn icon @click="toggleCard">
        <v-icon color="rgba(0,0,0,.87)">
          {{ showContent ? 'mdi-chevron-down-box' : 'mdi-chevron-right-box' }}
        </v-icon>
      </v-btn>
      <v-toolbar-title>
        <span>{{ title }}&nbsp;</span>
        <span v-if="!loading" class="ml-1 overline">({{ count }})</span>
        <template v-else>
          <span class="ml-1 overline">
            <v-progress-circular
              indeterminate
              color="primary"
              size="15"
              width="1"
              class="mb-1 mx-1"
            />
          </span>
        </template>
      </v-toolbar-title>
      <slot v-if="showContent" name="title-append" />
      <v-spacer />
      <slot v-if="showContent" name="actions" />
    </v-toolbar>
    <v-card-text v-show="showContent">
      <slot name="content" />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { debounce } from 'lodash-es';

import { UserWidgetsEnum } from '@/bundles/Settings/enums/userLayoutEnum';

export default Vue.extend({
  name: 'DashboardCard',

  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    widgetType: {
      type: String as PropType<UserWidgetsEnum>,
      required: true,
    },
    loading: Boolean,
    expanded: Boolean,
  },

  data: (): { showContent: boolean } => ({
    showContent: true,
  }),

  mounted () {
    this.showContent = this.expanded;
  },

  methods: {
    toggleCard () {
      this.showContent = !this.showContent;
      this.saveCardStateDebounced(this);
    },
    saveCardStateDebounced: debounce(function (vm) {
      vm.$emit('update:expanded', {
        name: vm.widgetType,
        value: vm.showContent
      });
    }, 400),
  }
});
</script>
